var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 29.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4563ab;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    className: "cls-1",
    d: "m30,14.91C29.95,6.62,23.19-.05,14.91,0,6.62.05-.05,6.81,0,15.09c.05,7.34,5.4,13.58,12.66,14.72v-10.55h-3.81v-4.36h3.81v-3.32c0-3.78,2.24-5.87,5.67-5.87,1.13.02,2.25.11,3.36.3v3.71h-1.89c-1.19-.15-2.28.69-2.44,1.88-.02.16-.02.32,0,.48v2.83h4.16l-.67,4.36h-3.5v10.55c7.31-1.18,12.68-7.5,12.67-14.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFacebook);
export default __webpack_public_path__ + "static/media/ico-facebook.648bb06c3a5fab20cc1c27bf2cace59b.svg";
export { ForwardRef as ReactComponent };